window.Shopify = window.Shopify || {};

function startBannerCookie() {
  if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
    window.Shopify.loadFeatures(
      [{ name: "consent-tracking-api", version: "0.1" }],
      function (error) {
        if (
          error &&
          (typeof error !== "object" || Object.keys(error).length > 0)
        ) {
          console.warn("Erro ao carregar consent-tracking-api:", error);
        }
        initCookieBanner();
      },
    );
  } else {
    initCookieBanner();
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", startBannerCookie);
} else {
  startBannerCookie();
}

function hasCustomerPrivacyApi() {
  return (
    window.Shopify &&
    window.Shopify.customerPrivacy &&
    typeof window.Shopify.customerPrivacy.setTrackingConsent === "function" &&
    typeof window.Shopify.customerPrivacy.currentVisitorConsent ===
    "function" &&
    typeof window.Shopify.customerPrivacy.shouldShowBanner === "function"
  );
}

function getVisitorConsentAsBooleans() {
  if (!hasCustomerPrivacyApi()) return null;

  try {
    const visitor = window.Shopify.customerPrivacy.currentVisitorConsent();
    if (!visitor) return null;

    function parseToBool(val) {
      if (typeof val === "string") return val.toLowerCase().trim() === "yes";
      return Boolean(val);
    }

    return {
      personalization: parseToBool(visitor.preferences),
      marketing: parseToBool(visitor.marketing),
      analytics: parseToBool(visitor.analytics),
    };
  } catch (err) {
    console.warn("Erro ao ler currentVisitorConsent:", err);
    return null;
  }
}

const storageKey = "vissla_cookie_consent";

// Fallback usado somente quando a Customer Privacy API não está disponível.
// Quando a API está disponível, o consentimento da Shopify é a fonte de verdade.
function getConsent() {
  try {
    const raw = localStorage.getItem(storageKey);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    console.warn("Não foi possível ler o consentimento salvo:", e);
    return null;
  }
}

function getEffectiveConsent() {
  if (hasCustomerPrivacyApi()) {
    try {
      const visitor = window.Shopify.customerPrivacy.currentVisitorConsent();

      const hasRealAnswer =
        visitor &&
        visitor.analytics !== "" &&
        visitor.marketing !== "" &&
        visitor.preferences !== "";

      if (hasRealAnswer) {
        const visitorConsent = getVisitorConsentAsBooleans();

        if (visitorConsent) {
          return {
            necessary: true,
            ...visitorConsent,
          };
        }
      }

      return null;
    } catch (e) {
      console.warn(
        "Erro ao consultar currentVisitorConsent em getEffectiveConsent:",
        e,
      );
      return null;
    }
  }

  // Fallback para temas/lojas onde a Customer Privacy API não está disponível.
  return getConsent();
}

function shouldDisplayBanner() {
  const currentConsent = getEffectiveConsent();

  if (currentConsent !== null) {
    return false;
  }

  if (hasCustomerPrivacyApi()) {
    try {
      return window.Shopify.customerPrivacy.shouldShowBanner();
    } catch (e) {
      console.warn(
        "Erro ao consultar shouldShowBanner em shouldDisplayBanner:",
        e,
      );
      return true;
    }
  }

  return true;
}

document.addEventListener("visitorConsentCollected", function () {
  try {
    const consent = getVisitorConsentAsBooleans();

    if (consent) {
      const data = {
        necessary: true,
        personalization: consent.personalization,
        marketing: consent.marketing,
        analytics: consent.analytics,
        timestamp: Date.now(),
      };

      // Mantido como fallback para ambientes sem Customer Privacy API.
      localStorage.setItem(storageKey, JSON.stringify(data));

      // Atualização do Google Consent Mode movida para o evento global
      window.dataLayer = window.dataLayer || [];

      function gtag() {
        window.dataLayer.push(arguments);
      }

      gtag("consent", "update", {
        analytics_storage: data.analytics ? "granted" : "denied",
        ad_storage: data.marketing ? "granted" : "denied",
        ad_user_data: data.marketing ? "granted" : "denied",
        ad_personalization: data.personalization ? "granted" : "denied",
      });
    }
  } catch (e) {
    console.warn(
      "Falha ao sincronizar consentimento com visitorConsentCollected:",
      e,
    );
  }
});

function initCookieBanner() {
  const popUp = document.querySelector(".banner-cookies-container");
  const acceptButton = document.querySelector(".banner-cookies-button-accept");
  const declineButton = document.querySelector(
    ".banner-cookies-button-decline",
  );
  const manageLink = document.querySelector(".banner-cookies-config");

  const modal = document.querySelector("#cookie-preferences-modal");
  const closeButton = document.querySelector(".cookie-preferences-close");
  const acceptAllButton = document.querySelector(
    ".cookie-preferences-accept-all",
  );
  const declineAllButton = document.querySelector(
    ".cookie-preferences-decline-all",
  );
  const saveButton = document.querySelector(".cookie-preferences-save");

  const personalizacaoToggle = document.querySelector(
    "#cookie-toggle-personalizacao",
  );
  const marketingToggle = document.querySelector("#cookie-toggle-marketing");
  const analiseToggle = document.querySelector("#cookie-toggle-analise");

  const cookieFab = document.querySelector(".cookie-fab");

  let previousActiveElement = null;

  function saveConsent(categories) {
    const data = {
      necessary: true,
      personalization: !!categories.personalization,
      marketing: !!categories.marketing,
      analytics: !!categories.analytics,
      timestamp: Date.now(),
    };

    try {
      // Mantido para fallback caso a Customer Privacy API não esteja disponível.
      localStorage.setItem(storageKey, JSON.stringify(data));
    } catch (e) {
      console.warn(
        "Não foi possível salvar o consentimento no localStorage:",
        e,
      );
    }

    try {
      if (hasCustomerPrivacyApi()) {
        window.Shopify.customerPrivacy.setTrackingConsent(
          {
            analytics: data.analytics,
            marketing: data.marketing,
            preferences: data.personalization,
          },
          function (error) {
            if (
              error &&
              (typeof error !== "object" || Object.keys(error).length > 0)
            ) {
              console.warn(
                "Erro ao salvar consentimento via setTrackingConsent:",
                error,
              );
            }
          },
        );
      } else {
        console.warn(
          "API Shopify.customerPrivacy não está disponível no momento do salvamento",
        );
      }
    } catch (e) {
      console.warn("Erro ao informar consentimento para Shopify:", e);
    }

    return data;
  }

  function showCookieFab() {
    if (cookieFab) {
      cookieFab.classList.remove("is-hidden");
      cookieFab.classList.add("is-visible");
    }
  }

  function hideCookieFab() {
    if (cookieFab) {
      cookieFab.classList.remove("is-visible");
      cookieFab.classList.add("is-hidden");
    }
  }

  function focusCookieFab() {
    if (cookieFab) {
      cookieFab.focus();
    }
  }

  function hideBanner() {
    if (popUp) {
      popUp.classList.remove("is-visible");
      popUp.classList.add("is-hidden");
    }
  }

  function showBanner() {
    if (popUp) {
      popUp.classList.remove("is-hidden");
      popUp.classList.add("is-visible");
    }

    hideCookieFab();
  }

  // Única fonte de verdade sobre o que deve estar visível.
  // Reavalia o estado atual sempre que chamada.
  function updateCookieUiVisibility() {
    if (shouldDisplayBanner()) {
      showBanner();
    } else {
      hideBanner();
      showCookieFab();
    }
  }

  function syncTogglesFromConsent(consent) {
    if (!consent) return;

    if (personalizacaoToggle) {
      personalizacaoToggle.checked = !!consent.personalization;
    }

    if (marketingToggle) {
      marketingToggle.checked = !!consent.marketing;
    }

    if (analiseToggle) {
      analiseToggle.checked = !!consent.analytics;
    }
  }

  function handleFocusTrap(e) {
    if (!modal || !modal.classList.contains("is-visible")) return;

    const focusableElements = modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    );

    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (e.key === "Tab") {
      if (e.shiftKey) {
        if (document.activeElement === firstElement) {
          lastElement.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === lastElement) {
          firstElement.focus();
          e.preventDefault();
        }
      }
    }
  }

  function openModal(e) {
    if (e) e.preventDefault();

    hideBanner();
    hideCookieFab();

    const current = getEffectiveConsent();

    if (current) {
      syncTogglesFromConsent(current);
    }

    if (modal) {
      previousActiveElement = document.activeElement;

      modal.classList.add("is-visible");
      modal.setAttribute("aria-hidden", "false");

      document.addEventListener("keydown", handleFocusTrap);

      const firstInput = modal.querySelector(
        'button, input, [tabindex]:not([tabindex="-1"])',
      );

      if (firstInput) {
        firstInput.focus();
      }
    }
  }

  function closeModal(focusTarget) {
    if (modal) {
      modal.classList.remove('is-visible');
      modal.setAttribute('aria-hidden', 'true');

      document.removeEventListener('keydown', handleFocusTrap);
    }
    updateCookieUiVisibility();

    if (modal) {
      const nextFocus = focusTarget || previousActiveElement;

      if (nextFocus && typeof nextFocus.focus === 'function') {
        nextFocus.focus();
      }
    }
  }
  updateCookieUiVisibility();

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal && modal.classList.contains("is-visible")) {
      closeModal(cookieFab);
    }
  });

  if (acceptButton) {
    acceptButton.addEventListener("click", function () {
      saveConsent({
        personalization: true,
        marketing: true,
        analytics: true,
      });

      hideBanner();
      showCookieFab();
      focusCookieFab();
    });
  }

  if (declineButton) {
    declineButton.addEventListener("click", function () {
      saveConsent({
        personalization: false,
        marketing: false,
        analytics: false,
      });

      hideBanner();
      showCookieFab();
      focusCookieFab();
    });
  }

  if (manageLink) {
    manageLink.addEventListener("click", openModal);
  }

  if (closeButton) {
    closeButton.addEventListener("click", function () {
      closeModal(cookieFab);
    });
  }

  if (cookieFab) {
    cookieFab.addEventListener("click", openModal);
  }

  if (modal) {
    modal.addEventListener("click", function (e) {
      if (e.target === modal) {
        closeModal(cookieFab);
      }
    });
  }

  if (acceptAllButton) {
    acceptAllButton.addEventListener("click", function () {
      if (personalizacaoToggle) {
        personalizacaoToggle.checked = true;
      }

      if (marketingToggle) {
        marketingToggle.checked = true;
      }

      if (analiseToggle) {
        analiseToggle.checked = true;
      }

      saveConsent({
        personalization: true,
        marketing: true,
        analytics: true,
      });

      closeModal(cookieFab);
    });
  }

  if (declineAllButton) {
    declineAllButton.addEventListener("click", function () {
      if (personalizacaoToggle) {
        personalizacaoToggle.checked = false;
      }

      if (marketingToggle) {
        marketingToggle.checked = false;
      }

      if (analiseToggle) {
        analiseToggle.checked = false;
      }

      saveConsent({
        personalization: false,
        marketing: false,
        analytics: false,
      });

      closeModal(cookieFab);
    });
  }

  if (saveButton) {
    saveButton.addEventListener("click", function () {
      saveConsent({
        personalization: personalizacaoToggle
          ? personalizacaoToggle.checked
          : false,

        marketing: marketingToggle ? marketingToggle.checked : false,

        analytics: analiseToggle ? analiseToggle.checked : false,
      });

      closeModal(cookieFab);
    });
  }

  window.VisslaCookies = {
    open: openModal,
  };
}